module.exports = __webpack_public_path__ + "img/IMG_5631 2.183e671b.jpg";